const butlerJob = {
  // HeroSection
  'butlerJob.hero.homeLink': 'ホーム',
  'butlerJob.hero.currentPage': '執事の仕事とは？',
  'butlerJob.hero.title': '執事の仕事とは？',
  'butlerJob.hero.titleEn': 'WHAT A BUTLER DOES',
  'butlerJob.hero.lead': '執事の仕事とは、雇主やゲストの暮らしと時間を預かり、求められる前に必要を整える専門職です。このページでは、日々の業務内容・一日の流れの一例・働く場・求められる資質を、職業ガイドとしてご紹介します。',
  'butlerJob.hero.imgAlt': '現代的なレジデンスのエントランスロビーで、黒モーニングコートに白手袋の男性執事がレセプションカウンター前に立ち手のひらで案内し、スーツの男女が並んで立つ様子',

  // JobDefinition
  'butlerJob.definition.label': 'DEFINITION',
  'butlerJob.definition.title': '一文で言うと、どんな職業か',
  'butlerJob.definition.titleEn': 'The Work in One Sentence',
  'butlerJob.definition.mainLine': '暮らしと時間の全体を預かり、先に整える職業。',
  'butlerJob.definition.sub1': '個々の作業ではなく「全体」を担う',
  'butlerJob.definition.para1': '執事の仕事とは、雇主の生活とその周囲で起こる出来事を全体として預かり、人・もの・時間・場を整えることです。掃除や配膳といった個々の作業だけを指すのではなく、それらが滞りなく回るように差配し、必要があれば自ら手を動かす——この「全体を見て整える」点に、ほかのサービス職との違いがあります。',
  'butlerJob.definition.sub2': '頼まれてからではなく、頼まれる前に',
  'butlerJob.definition.para2': 'この職業の中心にあるのは、指示を待たずに動くことです。相手の様子や予定の流れから次に必要になるものを読み、あらかじめ用意しておく。表に立って目立つ仕事ではなく、何ごとも起こらなかったように一日が過ぎることが、最良の成果とされます。',
  'butlerJob.definition.sub3': '任される範囲と、踏み込まない領域',
  'butlerJob.definition.para3': '一方で、何でも引き受ける代行業ではありません。守秘を守り、家庭や組織の内側に立ち入る職務であるからこそ、任される範囲と踏み込まない領域の線引きが常に求められます。この線引きの感覚もまた、執事の仕事を支える技術のひとつです。',

  // WorkDomains
  'butlerJob.domains.label': 'FIVE AREAS',
  'butlerJob.domains.title': '執事の仕事を5つの領域で見る',
  'butlerJob.domains.titleEn': 'Five Areas of Daily Work',
  'butlerJob.domains.lead': '業務は多岐にわたりますが、整理すると五つの領域に分けられます。どの領域も単独では完結せず、互いに重なり合いながら一日の働きを形づくります。',
  'butlerJob.domains.0.title': '来客の応対と給仕',
  'butlerJob.domains.0.desc': 'お出迎えからお見送りまで、来客の時間を預かる領域です。玄関でのご挨拶、上着やお荷物のお預かり、お茶や食事の提供、会話の潮目を読んだ着席・退席の補助まで含みます。ティーサービスやテーブルセッティングは、この領域の土台となる技術です。',
  'butlerJob.domains.0.imgAlt': 'ティーポットからカップへ静かに紅茶を注ぐ手元',
  'butlerJob.domains.1.title': '邸宅・空間の管理',
  'butlerJob.domains.1.desc': '住まいや施設そのものを整える領域です。衣類やリネンの手入れ、銀食器やグラス類の管理、季節に応じた設えの入れ替え、備品の補充と点検。日々の確認を積み重ねることで、「いつでも人を迎えられる状態」を保ちます。\n\n伝統的な英国執事の職務は「男性使用人と家政業務の統括」「ワインセラーの管理」「主人への直接的なサービス」「銀器・食器の管理」の四つに大きく分けられ、うち二つがこの領域にあたります。とりわけワインの管理は執事の原点ともいえる業務で、主人の好みに合わせてワインを選び、質を保つためにボトルの向きや保管位置に配慮し、季節に応じてセラーの温度や湿度を管理することが求められました。',
  'butlerJob.domains.1.imgAlt': '衣装部屋でモーニングコートの手入れをする執事',
  'butlerJob.domains.2.title': '予定と手配の調整',
  'butlerJob.domains.2.desc': '予定を組み、必要な手配を先に済ませる領域です。来客や行事の日程調整、移動の段取り、外部の店舗や業者との連絡、記念日や慣例の把握。予定表の上で先に問題を見つけ、当日に持ち込まないことが要点です。',
  'butlerJob.domains.2.imgAlt': '開いた手帳・懐中時計・白手袋が置かれた執務椅子',
  'butlerJob.domains.3.title': '人の采配',
  'butlerJob.domains.3.desc': '複数の担い手が関わる現場をまとめる領域です。誰がどの時間に何を担うかを決め、当日の動きを伝え、業務が重なる時間帯の負荷を調整します。指示の言葉づかいひとつで現場の空気が変わるため、対話の技術も欠かせません。',
  'butlerJob.domains.3.imgAlt': 'サロンでスタッフに当日の動きを伝える場面',
  'butlerJob.domains.4.title': '緊急時の対応',
  'butlerJob.domains.4.desc': '想定外が起きたときに動く領域です。体調の急変、設備の不具合、災害、不審な訪問——いずれも頻度は高くありませんが、起きた瞬間に最初の判断を求められる立場にあります。慌てず、周囲を落ち着かせながら関係先へつなぐ手順を身につけておく必要があります。',
  'butlerJob.domains.4.imgAlt': '体調がすぐれない方に付き添い、担当者へ引き継ぐ場面',

  // DayFlow
  'butlerJob.day.label': 'A DAY IN THE ROLE',
  'butlerJob.day.title': '一日の流れ（一例）',
  'butlerJob.day.titleEn': 'An Example of a Working Day',
  'butlerJob.day.lead': '働き方は勤務先や雇主のご事情によって大きく異なります。ここでは理解の助けとして、邸宅に勤める場合の一日を一例として組み立ててご紹介します。実在の特定のお宅の予定を示すものではありません。',
  'butlerJob.day.0.time': '朝',
  'butlerJob.day.0.title': '一日の準備',
  'butlerJob.day.0.desc': 'まず建物と設えを一巡します。玄関まわり、居室、食卓の状態を確かめ、朝の飲み物や新聞、その日に必要な衣類を整えます。あわせて予定を読み直し、天候や交通の状況から変更が要りそうな箇所を洗い出しておきます。',
  'butlerJob.day.1.time': '日中',
  'butlerJob.day.1.title': '応対と調整',
  'butlerJob.day.1.desc': '来客の応対、電話や書面の対応、外部の手配先とのやりとりが重なる時間帯です。予定の合間には、備品の補充や衣類の手入れといった管理業務を差し込みます。予定が動いたときは、影響が及ぶ相手へ早めに連絡を入れ、後ろの予定まで含めて組み直します。',
  'butlerJob.day.2.time': '夕刻',
  'butlerJob.day.2.title': '会食と設え',
  'butlerJob.day.2.desc': '会食がある日は、席次・器・飲み物の支度を段階的に進めます。人数や体調、召し上がれないものの有無を確かめ、当日の流れに合わせて出す順と間合いを決めます。会食のない日は、翌日以降の準備や手入れに時間を充てます。',
  'butlerJob.day.3.time': '夜',
  'butlerJob.day.3.title': '締めと翌日への備え',
  'butlerJob.day.3.desc': '一日の終わりに火元と戸締まりを確かめ、使った器や道具を元の状態へ戻します。最後に、その日に気づいたこと・翌日の予定・引き継ぐ事項を書き留めます。この記録の積み重ねが、翌日の先回りを支えます。',
  'butlerJob.day.note': '※上記はあくまで一例です。ホテルやレジデンスに勤める場合は交替制となることもあり、一日の流れは勤務先によって変わります。',
  'butlerJob.day.imgAlt': '傘を差し掛けてお客様に付き添う場面',
  'butlerJob.day.imgCaption': '傘を差し掛けてお送りする場面を想定した実習の様子',

  // Workplaces
  'butlerJob.places.label': 'WHERE BUTLERS WORK',
  'butlerJob.places.title': '執事の仕事が求められる場',
  'butlerJob.places.titleEn': 'Where the Role Is Needed',
  'butlerJob.places.lead': '活躍の場は個人のお宅だけではありません。住まい、宿泊施設、そして法人の接遇の現場へと広がっています。',
  'butlerJob.places.0.title': '個人邸',
  'butlerJob.places.0.desc': '一軒のお宅に関わり、暮らし全体を預かる働き方です。ご家族の生活時間に沿って動くため、担当する業務の幅がもっとも広くなります。',
  'butlerJob.places.0.imgAlt': '邸宅の寝室へ朝の飲み物をお運びする場面',
  'butlerJob.places.1.title': 'ホテル・レジデンス',
  'butlerJob.places.1.desc': '宿泊施設や居住施設で、滞在中のご要望に応える働き方です。担当が交替で入るため、引き継ぎの正確さと記録の丁寧さが問われます。',
  'butlerJob.places.1.imgAlt': 'ホテルのロビーでお茶をお出しする場面',
  'butlerJob.places.2.title': '法人の接遇の現場',
  'butlerJob.places.2.desc': '企業の受付・応接・催事など、来客をお迎えする現場でも執事の技術が生きます。所作と言葉づかいが、そのまま組織の印象として受け取られます。',
  'butlerJob.places.2.imgAlt': '夜のエントランスでお客様をお迎えする場面',
  'butlerJob.places.note': '※働き方や条件は勤務先によって幅があり、雇用の形も一様ではありません。具体的な条件は個別の募集内容や雇用契約でご確認ください。',

  // Income
  'butlerJob.income.label': 'INCOME',
  'butlerJob.income.title': '執事の年収はどのくらいか',
  'butlerJob.income.subtitleEn': 'What Butlers Earn',
  'butlerJob.income.lead': '執事の年収は、勤務地・経験年数・担当範囲・住み込みの有無によって大きく異なります。ここでは、2026年に公開された英国・米国・欧州の調査データを基に、確認できる水準をご紹介します。調査主体や対象とする雇用層によって数字に幅がある点にご留意ください。',
  'butlerJob.income.uk.title': '英国の年収水準',
  'butlerJob.income.uk.body': '英国では、調査の対象層によって示される年収の水準が異なります。2026年の英国の調査（Lighthouse Careers）では、経験0〜2年で年£35,000〜£45,000、経験3〜7年で年£50,000〜£70,000、経験8年以上で年£75,000〜£120,000とされています。\n\nロンドンでは同経験帯でも高めの傾向があり、上級では£80,000〜£120,000、メイフェアなどの高級地区ではさらに10〜15％の上乗せが見られるとされています。一方、UHNW層（超富裕層）の実求人に基づくとされる2026年のガイド（Oplu）では、英国の標準レンジを年£65,000〜£105,000、大規模邸宅のヘッドバトラーを年£95,000〜£150,000としており、一般的な求人を対象とした調査とUHNW層向けのガイドとで幅が出ています。\n\n住み込みの場合、住居価値はロンドンで年£15,000〜£25,000相当、地方で£8,000〜£15,000相当とされ、福利厚生を含めた総額は基本給に20〜30％上乗せ、賞与は基本給の5〜15％程度とする報告もあります。',
  'butlerJob.income.us.title': '米国の年収水準',
  'butlerJob.income.us.body': 'UHNW層を対象とした2026年のガイド（Oplu）によれば、米国の主邸クラスの年収は$110,000〜$190,000が示されています。いずれも総額・フルタイム・通い（live-out）を原則とした水準です。',
  'butlerJob.income.europe.title': '欧州大陸の水準',
  'butlerJob.income.europe.body': '同ガイドにおける欧州大陸の年収水準としては、モナコおよび南仏で手取り月€6,000〜€9,500、スイスで月CHF 7,500〜13,000とされています。こちらも総額・フルタイム・通いが原則とされています。',
  'butlerJob.income.factors.title': '年収を左右する要素',
  'butlerJob.income.factors.body': '年収は経験年数だけでなく、勤務地（都市部か地方か）、邸宅の規模、ヘッドバトラーか一般か、住み込みか通いか、福利厚生や賞与の有無によって変動します。英国の調査でも、ロンドンや高級地区では同経験帯でも高めの水準が示されており、住居提供の価値を含めた総報酬で比較する視点が重要です。',
  'butlerJob.income.japan.title': '日本の場合',
  'butlerJob.income.japan.body': '日本については、執事の年収に関する公表された公的統計や、広く参照できる調査データは現時点で確認できていません。雇用形態（住み込み・通い・常駐・スポット）、担当する業務の範囲、勤務先の種類によって年収は大きく異なると考えられます。具体的な条件は、個別の募集内容や雇用契約でご確認ください。',
  'butlerJob.income.note': '出典: Lighthouse Careers「Butler Salary UK: Complete Compensation Guide for 2026」（2026年5月17日更新）／Oplu「Private Staff Salary Guide 2026」（2026年4月26日公開・6月29日更新）。上記は各調査時点の海外データであり、就職や収入を保証するものではありません。為替換算は行っていません。実際の条件は個別の契約により異なります。',

  // Qualities
  'butlerJob.qualities.label': 'WHAT IT TAKES',
  'butlerJob.qualities.title': '求められる資質',
  'butlerJob.qualities.titleEn': 'Qualities the Work Demands',
  'butlerJob.qualities.lead': '執事の仕事は、華やかさよりも、一見地味に映る四つの資質に支えられています。いずれも生まれ持った素質ではなく、執事学校での反復訓練で伸ばせるものです。',
  'butlerJob.qualities.0.title': '観察力',
  'butlerJob.qualities.0.desc': '相手の仕草・視線・声の調子から、言葉になっていない要望を読み取る力です。まず気づけなければ、先回りは始まりません。',
  'butlerJob.qualities.1.title': '先回りの段取り',
  'butlerJob.qualities.1.desc': '起きてから動くのではなく、起きる前に手を打つ習慣です。予定の先を見て、必要になるものを静かに用意しておきます。',
  'butlerJob.qualities.2.title': '動じない冷静さ',
  'butlerJob.qualities.2.desc': '不測の事態でも表情と所作を保ち、周囲の不安を広げない落ち着きです。慌てないこと自体が、その場への貢献になります。',
  'butlerJob.qualities.3.title': '守秘の徹底',
  'butlerJob.qualities.3.desc': '知り得たことを外へ出さない——これは執事の仕事の前提条件です。信頼を欠けば、ほかのどの技術も意味を持ちません。',
  'butlerJob.qualities.imgAlt': '木製の飾り棚のガラス扉越しに、黒モーニングコートに白手袋の若い男性執事が金彩と紺の絵付けが施されたティーカップとソーサーの列を静かに整えており、ガラスにシャンデリアと臙脂のカーテンのある室内が映り込む手元寄りの様子',

  // Fitness
  'butlerJob.fit.label': 'IS IT FOR YOU',
  'butlerJob.fit.title': '向いている人・難しさを感じやすい人',
  'butlerJob.fit.titleEn': 'Who Thrives in This Role',
  'butlerJob.fit.lead': '適性は生まれつき決まるものではありませんが、傾向はあります。ご自身の性分と照らし合わせる材料としてご覧ください。',
  'butlerJob.fit.suitedTitle': '向いている方',
  'butlerJob.fit.suited.0': '人の様子の小さな変化に気づける方',
  'butlerJob.fit.suited.1': '手順を決めて、決めたとおりに積み上げるのが苦にならない方',
  'butlerJob.fit.suited.2': '主役ではなく、場を支える立場にやりがいを感じる方',
  'butlerJob.fit.suited.3': '聞いたことを口外しない習慣が身についている方',
  'butlerJob.fit.challengeTitle': '難しさを感じやすい方',
  'butlerJob.fit.challenge.0': '成果をその場で評価されないと気力が続きにくい方',
  'butlerJob.fit.challenge.1': '予定が動くことに強い抵抗を感じる方',
  'butlerJob.fit.challenge.2': '相手の都合より自分の段取りを優先したくなる方',
  'butlerJob.fit.note': '向き・不向きは固定されたものではありません。とりわけ観察と段取りは、反復練習でもっとも伸びやすい領域です。難しさを感じる項目があっても、訓練の対象と捉えていただければ十分です。',

  // PathToCareer
  'butlerJob.path.label': 'HOW TO START',
  'butlerJob.path.title': 'この職業に就くまでの道筋',
  'butlerJob.path.titleEn': 'The Path Into the Profession',
  'butlerJob.path.para1': '入口は一本ではありません。ホテルやレストランなど接遇の現場から移る方もいれば、まったく別の職種から学び直して入る方もいます。共通しているのは、現場に出る前に執事学校で「型」を一度きちんと身につけておくと、その後の伸び方が変わるという点です。',
  'butlerJob.path.para2': '日本執事アカデミーは、東京・お台場で実際に通学できる本校を有しており、日本で唯一の学び舎を持つ執事養成学校として、その「型」を体系的に学べる場を用意しています。講義で理由を理解し、実技で身体に入れ、ロールプレイングで実戦に近い状況を経験する——課程はこの循環で組み立てられています。所定の課程を修了し審査に合格すると、全日本執事協会認定のバトラー資格を取得できます。',
  'butlerJob.path.para3': '執事学校で何を学ぶのかを先に知りたい方は、カリキュラムや習得スキルのページをご覧ください。実際の空気に触れてから決めたい方には、一日完結の体験講座もご用意しています。',
  'butlerJob.path.imgAlt': '東京・お台場に構える本校の校舎',
  'butlerJob.path.linkCurriculum': 'カリキュラム概要を見る',
  'butlerJob.path.linkSkills': '習得スキル一覧を見る',
  'butlerJob.path.linkSeminar': '体験講座を見る',

  // FAQ
  'butlerJob.faq.label': 'FAQ',
  'butlerJob.faq.title': 'よくあるご質問',
  'butlerJob.faq.titleEn': 'Frequently Asked Questions',
  'butlerJob.faq.footer': 'その他のご質問はお問い合わせフォームよりお寄せください',
  'butlerJob.faq.0.question': '執事の仕事内容を一言でいうと何ですか？',
  'butlerJob.faq.0.answer': '雇主やゲストの暮らしと時間を預かり、求められる前に必要を整える仕事です。来客の応対と給仕、邸宅・空間の管理、予定と手配の調整、人の采配、緊急時の対応という五つの領域にまたがります。',
  'butlerJob.faq.1.question': 'ハウスキーパーや秘書とは何が違いますか？',
  'butlerJob.faq.1.answer': '担当する範囲が異なります。個々の作業や事務を担うのではなく、暮らしと予定の全体を見渡して差配し、必要に応じて自ら手を動かすのが執事の仕事です。英国の邸宅では、ハウスキーパーは室内の女性使用人のリーダーとして、リネンや陶磁器の管理、日用品の購入・支給を受け持ち、掃除を担当するハウスメイドを統括する役職でした。\n\n一方の執事は、部下のフットマンを監督し、酒類や銀器の管理と食卓の給仕を担い、家令（スチュワード）が置かれていない邸宅では人事・経理までを引き受けて使用人のトップを務めます。家令は家内使用人のトップに立つ役職ですが、置かれたのは非常に大きな邸宅にかぎられていたため、多くの邸宅では執事が実質的な長でした。予定管理や書面の対応といった秘書に近い職務も執事の仕事に含まれますが、それはあくまで暮らし全体を差配するための一部という位置づけです。',
  'butlerJob.faq.2.question': '一日はどのように進みますか？',
  'butlerJob.faq.2.answer': '一例として、朝に建物と設えを整え、日中は応対と調整、夕刻に会食の支度、夜に締めと翌日の準備を行います。ただし勤務先や雇主のご事情によって流れは大きく変わります。',
  'butlerJob.faq.3.question': '勤務条件はどのようなものですか？',
  'butlerJob.faq.3.answer': '勤務形態・勤務時間・住み込みの有無などの勤務条件は、雇用先により異なります。具体的な条件は個別の募集内容や雇用契約でご確認ください。海外の調査データは別項でご案内しています。',
  'butlerJob.faq.4.question': '未経験から目指せますか？',
  'butlerJob.faq.4.answer': 'はい。異なる職種から学び直して目指す方もいらっしゃいます。日本執事アカデミーでは基礎から段階的に積み上げる課程をご用意しており、執事養成学校としての実技中心の訓練を通じて、未経験の方も型から身につけられます。',
  'butlerJob.faq.5.question': '執事の年収はどのくらいですか？',
  'butlerJob.faq.5.answer': '年収は勤務する国・地域や経験、担当範囲、住み込みの有無などで幅があります。2026年の英国調査では経験0〜2年で£35,000〜£45,000、経験3〜7年で£50,000〜£70,000、経験8年以上で£75,000〜£120,000、UHNW層を対象とした2026年のガイドでは米国の主邸クラスで$110,000〜$190,000といった水準が示されています。\n\n日本については公表された公的統計が確認できておらず、一律の水準はお示しできません。国・地域別の年収の目安は、本ページの解説をご覧ください。',

  // CTA
  'butlerJob.cta.label': 'NEXT STEP',
  'butlerJob.cta.title': '学びから始めるという選択',
  'butlerJob.cta.body': '執事の仕事の全体像をつかんだら、次は学び方をご覧ください。日本執事アカデミーは、執事養成学校として基礎から実技までを体系的にお伝えしています。',
  'butlerJob.cta.note': '※ご相談はオンラインでも承ります',
  'butlerJob.cta.courses': 'コースを見る',
  'butlerJob.cta.consultation': '個別相談を予約する',

  // RelatedPages
  'butlerJob.related.label': 'LEARN MORE',
  'butlerJob.related.title': '関連ページ',
  'butlerJob.related.titleEn': 'Explore Further',
  'butlerJob.related.viewLink': '詳しく見る',
  'butlerJob.related.backLink': '日本執事アカデミーについて知る',
  'butlerJob.related.0.title': '習得スキル一覧',
  'butlerJob.related.0.desc': '身につく5つのスキル領域',
  'butlerJob.related.1.title': 'カリキュラム概要',
  'butlerJob.related.1.desc': '学びの全体像と進め方',
  'butlerJob.related.2.title': '実践トレーニング',
  'butlerJob.related.2.desc': '実技とロールプレイング中心の訓練',
  'butlerJob.related.3.title': 'コース一覧・比較',
  'butlerJob.related.3.desc': '3つのコースの違いを一覧で確認',
  'butlerJob.related.4.title': '修了証・認定資格について',
  'butlerJob.related.4.desc': '修了で得られる協会認定資格',
  'butlerJob.related.5.title': '体験講座',
  'butlerJob.related.5.desc': '1日で執事の所作を体験',

  // Last updated
  'butlerJob.lastUpdated': '最終更新: 2026年7月25日',
};

export default butlerJob;
